module.exports = {
  version: '0.1.21',
  build: new Date(),
};



// WEBPACK FOOTER //
// ../release.js